import { useCallback, useEffect, useState } from "react";
import { fetchPortfolioRiskAnalysis } from "../../services/riskFinancingApi";

export default function usePortfolioRiskAnalysis({ enabled = false, simulations } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!Number.isFinite(simulations) || simulations <= 0) return null;
    try {
      setLoading(true);
      setError(null);
      const result = await fetchPortfolioRiskAnalysis(simulations);
      setData(result);
      return result;
    } catch (requestError) {
      setError(requestError);
      return null;
    } finally {
      setLoading(false);
    }
  }, [simulations]);

  useEffect(() => {
    if (enabled) load();
  }, [enabled, load]);

  return { data, loading, error, refresh: load };
}
